export type { ProductItemType } from "./ProductItem-component";
export { default } from "./ProductItem-component";
